// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jMr2rx","arrow":"DSQ_Q6","popup":"_IcTVh","dark":"Sl4w_E","light":"TNY8Qy","line":"eMtAVL"};